import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingMedical from "./pages/LandingMedical";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingMedical />} />
      </Routes>
    </Router>
  );
}

export default App;